// React
import React, { useCallback, useState } from 'react';
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledButtonDropdown,
} from 'reactstrap';

// DataTable
import DataTable from 'react-data-table-component';

// Scss
import '../../../../assets/scss/pages/_datatable-search.scss';

export const SelectTable = ({
  title,
  columns,
  data,
  actions = [],
  handleDelete,
  hasStatusSelect = false,
  handleStatusSelect,
  loading,
  ...rest
}) => {
  const [registerId, setRegisterId] = useState(null);
  const [modal_delete, setModal_delete] = useState(false);
  // const [currentStatus, setCurrentStatus] = useState('Ativos');

  const toggleModal = useCallback(
    (id) => {
      setRegisterId(id);
      setModal_delete(!modal_delete);
    },
    [modal_delete]
  );

  const createColumnsWithActionsData = useCallback(
    (cellProps) => {
      let columns = (actions || []).map((item) => {
        return (
          <DropdownItem
            key={item.id}
            title={item.label}
            className="dropdown-item"
            onClick={() => {
              item.onPress(cellProps);
            }}
          >
            <i
              className={`las ${item.icon} fs-20 text-${item.classNameColorIcon}`}
            ></i>
            {item.label}
          </DropdownItem>
        );
      });

      return columns;
    },
    [actions, toggleModal]
  );

  return (
    <>
      <DataTable
        {...rest}
        data={data}
        loading={true}
        columns={[
          ...columns,
          {
            name: <span className="font-weight-bold fs-13"> </span>,
            sortable: false,
            style: {
              justifyContent: 'end',
            },
            cell: (cellProps) => {
              return (
                <Dropdown>
                  <UncontrolledButtonDropdown>
                    <DropdownToggle
                      hidden={cellProps.can_delete === false}
                      nav
                      className="las la-ellipsis-v text-primary fs-18"
                    ></DropdownToggle>
                    <div
                      style={{
                        position: 'fixed',
                        zIndex: '999',
                      }}
                    >
                      <DropdownMenu>
                        {createColumnsWithActionsData(cellProps)}
                        {handleDelete && (
                          <>
                            {actions.length > 0 && <DropdownItem divider />}

                            <DropdownItem
                              className="dropdown-item"
                              onClick={() => {
                                toggleModal(cellProps.id);
                              }}
                            >
                              <i className="las la-trash fs-20 text-danger" />
                              Excluir
                            </DropdownItem>
                          </>
                        )}
                      </DropdownMenu>
                    </div>
                  </UncontrolledButtonDropdown>
                </Dropdown>
              );
            },
          },
        ]}
        paginationComponentOptions={{
          rowsPerPageText: 'Linhas por página:',
          rangeSeparatorText: 'de',
          selectAllRowsItem: true,
          selectAllRowsItemText: 'Todos',
        }}
      />
    </>
  );
};
